import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { StyledWrapper } from '../styled';
import { fontUi, pill, viewMoreLink } from '../../theme/typography';

export const StyledNewWrapper = styled(StyledWrapper)`
  flex-direction: column;
`;

export const StyledTeamCard = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin: 0;
  > img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    flex-shrink: 0;
  }
  @media only screen and (max-width: 700px) {
    flex-wrap: wrap;
  }
`;

export const StyledBlockContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 1199px) {
    flex-direction: column;
  }
`;

export const StyledContainer = styled.div`
  height: 100%;
  margin: 0 0px;
  justify-content: space-between;

  &.first {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex: 1;
    @media screen and (max-width: 1199px) {
      width: 100%;
      flex: none;
      margin: 0;
    }
  }
  &.second {
    width: 100%;
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 1199px) {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 0;
    }
    margin: 0 0px;
  }
`;

export const StyledLobbySection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 25px;
  width: 100%;
  @media only screen and (max-width: 1199px) {
    flex-direction: column;
    gap: 25px;
  }
`;

export const StyledHomeColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 25px;
  @media only screen and (max-width: 1199px) {
    display: contents;
    width: 100%;
  }
`;
export const StyledTeamName = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  padding: 12px 16px;
  border-radius: ${({ theme }) => theme.cardRadius};
  box-sizing: border-box;
  @media only screen and (max-width: 1199px) {
    width: 100%;
    padding: 12px 14px;
  }
`;

export const StyledClubBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  justify-content: flex-end;
`;

export const StyledClubMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  padding: 0 16px 10px;
  box-sizing: border-box;
  @media only screen and (max-width: 1199px) {
    padding: 0 14px 8px;
  }
`;

export const StyledClubMetaValue = styled.span`
  ${fontUi};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledClubFormPills = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
`;

export const StyledClubFormPill = styled.span`
  ${fontUi};
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background: ${({ $result, theme }) => {
    if ($result === 'W') return '#00b56a';
    if ($result === 'L') return '#e94235';
    if ($result === 'D') return theme.textFaint;
    return 'transparent';
  }};
  border: ${({ $result, theme }) =>
    $result ? '0' : `1px solid ${theme.border}`};
`;

export const StyledClubShortcuts = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1px;
  background: ${({ theme }) => theme.borderSubtle};
  border-top: 1px solid ${({ theme }) => theme.border};
`;

export const StyledClubShortcut = styled(Link)`
  ${fontUi};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
  padding: 10px 12px;
  text-decoration: none;
  color: inherit;
  background: ${({ theme }) => theme.card};
  &:hover {
    background: ${({ theme }) => theme.hover};
  }
  svg {
    display: block;
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    color: ${({ theme }) =>
      theme.isDark ? theme.headerAccent : theme.success};
  }
`;

export const StyledClubShortcutLabel = styled.span`
  ${fontUi};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const StyledClubStack = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  align-self: stretch;
  @media only screen and (max-width: 1199px) {
    order: 1;
    width: 100%;
  }
`;

export const StyledTodoStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 240px;
  flex-shrink: 0;
  align-self: stretch;
  @media only screen and (max-width: 1199px) {
    order: 3;
    width: 100%;
  }
`;

export const StyledTeamStats = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 8px 4px 8px;
  flex: 1;
  min-height: 0;
  @media only screen and (max-width: 1199px) {
    width: 100%;
    flex-direction: column;
    max-width: 100%;
  }
`;

export const StyledInfoLabel = styled.span`
  ${pill};
  cursor: pointer;
  padding: 7px 12px;
  background-color: #fdca40;
  color: #000000;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 10px;
  margin: 0;
`;
export const StyledRankingContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 0 0 auto;
  flex: 1 1 auto;
  max-width: 100%;
  min-width: 0;
  @media only screen and (max-width: 700px) {
    margin-left: 0;
    width: 100%;
    justify-content: flex-start;
  }
`;

export const StyledSmallStats = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  border-radius: 12px;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 1199px) {
    width: 100%;
    //margin-top: 20px;
  }
`;

export const StyledLeagueLabel = styled.span`
  ${fontUi};
  color: ${({ theme }) => theme.textFaint};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 1.28px;
  text-transform: uppercase;
`;

export const StyledTeamTextFields = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 160px;
  min-width: 0;
  > h1 {
    margin: 0 0 2px;
    ${fontUi};
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: 0;
    width: auto;
    max-width: 100%;
    text-transform: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const SyledTopLeftSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  gap: 25px;
  order: 1;

  @media only screen and (max-width: 1199px) {
    width: 100%;
    flex-direction: column;
    height: auto;
    display: contents;
  }
`;

export const StyledMatchRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);
  grid-template-areas: 'next calendar';
  align-items: stretch;
  gap: 25px;
  width: 100%;
  order: 2;
  @media only screen and (max-width: 1199px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'next'
      'calendar';
    order: 2;
  }
`;

export const StyledHalfWidthSection = styled.div`
  width: 100%;
  order: 3;
  @media only screen and (max-width: 1199px) {
    display: none;
  }
`;

export const StyledTeamInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  width: auto;
  min-width: 0;
  max-width: none;
  overflow: hidden;
  @media only screen and (max-width: 1199px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledClubPulse = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));
  gap: 1px;
  margin-top: auto;
  background: ${({ theme }) => theme.borderSubtle};
  border-top: 1px solid ${({ theme }) => theme.border};
`;

export const StyledViewMore = styled(Link)`
  ${viewMoreLink};
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledClubStat = styled(Link)`
  ${fontUi};
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 10px 12px 12px;
  text-decoration: none;
  color: inherit;
  background: ${({ theme }) => theme.card};
  &:hover {
    background: ${({ theme }) => theme.hover};
  }
`;

export const StyledClubStatValue = styled.span`
  ${fontUi};
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme, $tone }) => ($tone === 'danger' ? theme.danger : theme.text)};
`;

export const StyledClubStatLabel = styled.span`
  ${fontUi};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.textFaint};
`;
